const TAGS = ['/scripts/hotjar.js', '/scripts/meta-pixel.js', '/scripts/barion-pixel.js'];

function loadTags() {
    TAGS.forEach((src) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        document.body.appendChild(script);
    });
}

export default () => {
    let started = false;
    const start = () => {
        if (started) return;
        started = true;
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(loadTags, { timeout: 2000 });
        } else {
            setTimeout(loadTags, 1);
        }
    };

    window.addEventListener('load', start, { once: true });
    ['pointerdown', 'keydown'].forEach((eventName) => {
        window.addEventListener(eventName, start, { once: true, passive: true });
    });
};
